import { render, staticRenderFns } from "./file-card.vue?vue&type=template&id=bbc3ab5c&scoped=true"
import script from "./file-card.vue?vue&type=script&lang=js"
export * from "./file-card.vue?vue&type=script&lang=js"
import style0 from "./file-card.vue?vue&type=style&index=0&id=bbc3ab5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc3ab5c",
  null
  
)

export default component.exports